import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { EASE, Reveal } from "@/components/Reveal";

const LINES = ["READY TO", "MOVE?"];

export function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative scroll-mt-20 overflow-hidden border-t border-white/10 bg-[#0a0a0a] px-6 py-32 lg:px-12 lg:py-48"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-[#FF3B30]/15 blur-[140px]"
      />

      <Reveal>
        <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-white/50">
          <span className="h-px w-10 bg-[#FF3B30]" />
          Start a shipment
        </p>
      </Reveal>

      <motion.h2
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-12% 0px" }}
        className="mt-8 font-display font-semibold uppercase leading-[0.85] tracking-tighter"
      >
        {LINES.map((line, i) => (
          <span key={line} className="block overflow-hidden">
            <motion.span
              variants={{
                hidden: { y: "112%" },
                show: {
                  y: 0,
                  transition: { duration: 1.1, delay: i * 0.12, ease: EASE },
                },
              }}
              className={`block text-[16vw] lg:text-[10rem] ${
                i === 1 ? "text-outline" : ""
              }`}
              data-testid={`contact-line-${i + 1}`}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </motion.h2>
        
      <div className="mt-14 flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
        <Reveal delay={0.2}>
          <p className="max-w-md text-base leading-relaxed text-white/70 md:text-lg">
            Tell us what needs to move and where. A lane specialist answers
            within one working hour - with a price, a plan and a departure
            date.
          </p>
          <div className="mt-8 space-y-2 text-sm text-white/50">
            <p data-testid="contact-phone">+91 92320 69697</p>
            <div data-testid="contact-hq" className="space-y-1">
              <p>Flat No.: GISN 00239</p>
              <p>C/O VANSHROOP VISHWAKRMA Khamhari</p>
              <p>District: Rewa, Madhya Pradesh</p>
              <p>PIN Code: 486111</p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <a
            href="mailto:sales@portwaveintl.com"
            data-testid="contact-email-link"
            className="group relative inline-flex overflow-hidden bg-[#FF3B30] px-10 py-5 text-xs font-bold uppercase tracking-[0.25em] text-white"
          >
            <span className="absolute inset-0 translate-y-full bg-white transition-transform duration-300 ease-out group-hover:translate-y-0" />
            <span className="relative z-10 flex items-center gap-3 transition-colors duration-300 group-hover:text-black">
              sales@portwaveintl.com
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
            </span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
